import React from 'react';
import { Link } from 'react-router-dom';
import SideBar from './SideBar';
import HeaderSection from './HeaderSection';

export default function Catalog() {

    return (
        <>
            <div className="container-scroller">
                <SideBar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <HeaderSection />
                        <div className="ceta-log-saction">
                            <h2>Apps Catalog</h2>
                            <div className="row">
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/google-reviews">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/google-reviews.png`} alt="google-reviews" className='silver-icon' />
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Google Reviews</h3>
                                                <p>Embed reviews for your business from Google right on your site</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                  <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/amazon-reviews">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/amazon.png`} alt="amazon-reviews" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Amazon Reviews </h3>
                                                <p>Share reviews about your products or store from Amazon on your site.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/aliexpress-reviews">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/AliExpress.png`} alt="aliexpress-reviews" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>AliExpress Reviews </h3>
                                                <p>Reveal reviews on your products from AliExpress on your site.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/yelp-reviews">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/Yelp.png`} alt="yelp-reviews" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Yelp Reviews </h3>
                                                <p>Demonstrate reviews on your services from Yelp on your site.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                 <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/g2-reviews">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/G2.png`} alt="g2-reviews" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>G2 Reviews </h3>
                                                <p>Display the best reviews on your services from G2 on your site.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                 <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/hotels-reviews">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/Hotel.png`} alt="hotels-reviews" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Hotels Reviews </h3>
                                                <p>Demonstrate reviews on your hotel from Hotels.com on your site.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                 <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/app-store-reviews">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/App-Store.png`} alt="app-store-reviews" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>App Store Reviews </h3>
                                                <p>Embed reviews on your apps from Apple App Store on your site.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>

                                 <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/capterra-reviews">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/Capterra-Top-Head.png`} alt="capterra-reviews" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Capterra Reviews </h3>
                                                <p>Display business reviews from Capterra on your website.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                 <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/booking-reviews">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/Booking.png`} alt="booking-reviews" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Booking Reviews </h3>
                                                <p>Reveal positive reviews on your place from Booking.com on your site.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                 <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/tripadvisor-reviews">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/Tripadvisor.png`} alt="tripadvisor-reviews" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Tripadvisor Reviews </h3>
                                                <p>Show reviews on your place from Tripadvisor right on your site.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                 <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/airbnb-reviews">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/Airbnb.png`} alt="airbnb-reviews" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Airbnb Reviews </h3>
                                                <p>Share the best reviews about your apartments from Airbnb on your site.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                  <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/airbnb-reviews">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/facebook.png`} alt="airbnb-reviews" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Facebook Reviews </h3>
                                                <p>Display reviews from your Facebook page on your site.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                  <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/airbnb-reviews">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/bbb.png`} alt="airbnb-reviews" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>BBB Reviews </h3>
                                                <p>Showcase the best reviews on your business from BBB on your site.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                  <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/airbnb-reviews">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/etsy.png`} alt="airbnb-reviews" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Etsy Reviews </h3>
                                                <p>Display reviews on your merchandise from Etsy on your site.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                  <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/airbnb-reviews">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/opentable.png`} alt="airbnb-reviews" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>OpenTable Reviews </h3>
                                                <p>Showcase best customer reviews on your restaurant from OpenTable on your site.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>

                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/airbnb-reviews">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/Instagram_Feed.png`} alt="airbnb-reviews" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Instagram Feed </h3>
                                                <p>Add posts from your Instagram account or by hashtag to your website.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                 
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/whats-app-chat">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/whats-app-chat.png`} alt="whats-app-chat" className='silver-icon' />
                                            </div>
                                            <div className="text-box-left">
                                                <h3>WhatsApp Chat</h3>
                                                <p>Give users an opportunity to contact you on WhatsApp straight from your website</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                
                                 <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/instagram-chat">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/instagram.png`} alt="instagram-chat" className='silver-icon' />
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Instagram Chat</h3>
                                                <p>Bring the power of Instagram Direct to your website - offer your visitors a hassle-free way to contact you on Instagram.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                 <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/telegram-chat">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/telegram.png`} alt="telegram-chat" className='silver-icon' />
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Telegram Chat</h3>
                                                <p>Give your audience the option to get in touch with you on Telegram.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                 <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/line-chat">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/line.png`} alt="line-chat" className='silver-icon' />
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Line Chat</h3>
                                                <p>Let users reach you out on Line directly from your resource.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                 <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/viber-chat">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/viber.png`} alt="viber-chat" className='silver-icon' />
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Viber Chat</h3>
                                                <p>Let users message you on Viber directly from your website.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                 <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/facebook-chat">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/facebook-chat.png`} alt="facebook-chat" className='silver-icon' />
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Facebook Chat</h3>
                                                <p>Allow users to contact you on Facebook Messenger from your website.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                               


                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/countdown-timer">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/countdown-timer.png`} alt="countdown-timer" className='silver-icon' />
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Countdown Timer </h3>
                                                <p>Create Timers and Counters to boost sales by urgency on your website</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/testimonials">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/testimonials.png`} alt="testimonials" className='silver-icon' />
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Testimonials Slider</h3>
                                                <p>Demonstrate your customer testimonials on your website</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/click-to-call">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/click-to-call.png`} alt="click-to-call" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Click to Call </h3>
                                                <p>Provide users with the fastest way to call you directly from your website</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/cookie-consent">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/cookie-consent.png`} alt="cookie-consent" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Cookie Consent </h3>
                                                <p>Use a convenient way to notify users about the cookies</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/age-verification">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/age-verification.png`} alt="age-verification" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Age Verification </h3>
                                                <p>Verify age to restrict underage users from access to your website</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/business-hours">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/business-hours.png`} alt="business-hours" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Business Hours </h3>
                                                <p>Showcase business hours and contact details on your website for user-friendly visit planning.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/announcement-bar">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/announcement-bar.png`} alt="announcement-bar" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Announcement Bar </h3>
                                                <p>Instantly inform visitors on your website with key updates, sales, news via a sleek bar.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                             
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/number-counter">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/number-counter.png`} alt="number-counter" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Number Counter </h3>
                                                <p>Boast your marvelous achievements and impressive numbers to your users.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                              
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/back-to-top">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/back-to-top.png`} alt="back-to-top" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Back to Top </h3>
                                                <p>Let your users instantly scroll to the top of the page in a click.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/social-media-icons">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/social-media-icons.png`} alt="social-media-icons" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Social Media Icons </h3>
                                                <p>Add social icons to your website for instant access to your social profiles.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/facebook-like-button">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/facebook-like-button.png`} alt="facebook-like-button" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Facebook Like Button </h3>
                                                <p>Let people like your content via Facebook.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/facebook-share-button">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/facebook-share-button.png`} alt="facebook-share-button" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Facebook Share Button </h3>
                                                <p>Let people share your content on Facebook.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/qr-code">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/qr-code.png`} alt="qr-code" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>QR Code </h3>
                                                <p>Use a QR code on your website to help people get any info instantly on their phones.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/logo-showcase">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/logo-showcase.png`} alt="logo-showcase" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Logo Showcase </h3>
                                                <p>Showcase logos of your clients, partners, brands and vendors on your website.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/team-showcase">
                                            <div className="icon-box-left">
                                            <img src={`${process.env.PUBLIC_URL}/images/catalog/team-showcase.png`} alt="team-showcase" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Team Showcase </h3>
                                                <p>Demonstrate your team and tell more about each member.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/faq">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/faq.png`} alt="faq" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>FAQ </h3>
                                                <p>Demonstrate the answers to the most common questions on your website.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>

                                 <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/spinning-wheel">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/spinningwheel.png`} alt="faq" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Spinning Wheel </h3>
                                                <p>Let visitors spin the wheel for a reward, motivating them to make a purchase.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                 <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/pdf-embed">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/pdfembed.png`} alt="faq" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>Pdf Embed </h3>
                                                <p>Let people view and download PDF files right from your website.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                 <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/file-embed">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/fileembed.png`} alt="faq" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>File Embed </h3>
                                                <p>Allow people view and download any kind of file (doc, xlsx, pptx, txt, etc.).</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                 <div className="col-md-6 col-lg-4 col-12">
                                    <div className="ceta-log-saction-box">
                                        <Link to="/customer/apps/ai-chatbot">
                                            <div className="icon-box-left">
                                                <img src={`${process.env.PUBLIC_URL}/images/catalog/AIchatbot.png`} alt="faq" className='silver-icon' /> 
                                            </div>
                                            <div className="text-box-left">
                                                <h3>AI Chatbot </h3>
                                                <p>Create a virtual assistant trained on your data to answer your customers’ questions 24/7.</p>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                                
                              

                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
